import { Box, Text } from '@mantine/core'

const VARIANT_COLORS = {
  danger: { border: '#e03131', bg: 'rgba(224,49,49,0.05)', title: '#e03131' },
  info: { border: '#098d93', bg: 'rgba(9,141,147,0.05)', title: '#098d93' },
  warning: { border: '#f59f00', bg: 'rgba(245,159,0,0.05)', title: '#856404' },
  success: { border: '#2f9e44', bg: 'rgba(47,158,68,0.05)', title: '#2f9e44' },
} as const

interface CalloutProps {
  variant: keyof typeof VARIANT_COLORS
  title?: string
  children: React.ReactNode
}

export function Callout({ variant, title, children }: CalloutProps) {
  const colors = VARIANT_COLORS[variant]
  return (
    <Box
      style={{
        borderLeft: `5px solid ${colors.border}`,
        backgroundColor: colors.bg,
        borderRadius: '0 var(--mantine-radius-sm) var(--mantine-radius-sm) 0',
        padding: '12px 16px',
        marginBottom: 16,
      }}
    >
      {title && (
        <Text fw={700} size="sm" mb={4} style={{ color: colors.title }}>
          {title}
        </Text>
      )}
      <Text size="sm" c="var(--ai-text-secondary)">{children}</Text>
    </Box>
  )
}
